/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Error_GenericInputs */

const fr_membership_freeze_error_generic = /** @type {(inputs: Membership_Freeze_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de mettre votre abonnement en pause. Veuillez réessayer plus tard.`)
};

/**

* @param {Membership_Freeze_Error_GenericInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_error_generic = /** @type {((inputs?: Membership_Freeze_Error_GenericInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Error_GenericInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_error_generic(inputs)
});